package com.tovtalk.domain.entity

import kotlin.time.Instant

/**
 * Comment Entity - תגובה לפוסט
 */
data class Comment(
    val id: Int,
    val postId: Int,
    val userId: Int,
    val text: String?,
    val gifUrl: String?,
    val likes: Long = 0,
    val replyCount: Long = 0,
    val isLiked: Boolean = false,
    val isPinned: Boolean = false,
    val user: User? = null,
    val replies: List<ReplyComment> = emptyList(),
    val createdAt: Instant,
    val updatedAt: Instant
)

/**
 * Reply Comment - תגובה לתגובה
 */
data class ReplyComment(
    val id: Int,
    val commentId: Int,
    val userId: Int,
    val text: String?,
    val gifUrl: String?,
    val likes: Long = 0,
    val isLiked: Boolean = false,
    val user: User? = null,
    val createdAt: Instant,
    val updatedAt: Instant
)
